import MojitoPresentation from 'mojito/presentation';
import CompetitorIcon from 'presentation/components/competitor-icon/index.js';

const { CountryIcon, SportIcon } = MojitoPresentation.Components;

const CountryOrSportIcon = ({ countryCode, countryName, sportId, iconUrl, mojitoTools }) => {
    const { config } = mojitoTools;

    if (iconUrl) {
        return <CompetitorIcon config={config.competitorIcon} src={iconUrl} title={countryName} />;
    }

    if (countryCode && config.countryIcon.countryIcons[countryCode]) {
        return (
            <CountryIcon
                config={config.countryIcon}
                countryCode={countryCode}
                countryName={countryName}
                class="ta-MeetingCountryIcon"
            />
        );
    }

    return <SportIcon sportId={sportId} config={config.sportIcon} class="ta-MeetingSportIcon" />;
};

export default CountryOrSportIcon;
